import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useCallback, useContext } from 'react';
import styled from 'styled-components';
import { noop } from "../../utils/noop";
import { MenuRadioGroupContext } from "./MenuRadioGroup";
import { MenuButton } from "./MenuButton";
import { theme } from "../../theme";
import { IconCheckmark } from "@frameio/vapor-icons/build/esm/icons/IconCheckmark";
var _theme$transitions = theme.transitions,
    eases = _theme$transitions.eases,
    durations = _theme$transitions.durations;
var CheckedSVG = styled(IconCheckmark).withConfig({
  displayName: "MenuRadio__CheckedSVG",
  componentId: "vapor__sc-1fboix4-0"
})(["opacity:0;transform:scale(0) translateX(", ");transition:", " ", ";", ""], theme.spaces[4], durations[100], eases.primary, function (p) {
  return p.$isChecked && "\n    opacity: 1;\n    transform: scale(0.8) translateX(".concat(theme.spaces[4], ");\n  ");
});
/**
 * MenuRadio
 *
 * A radio button which composes MenuItem. This
 * should be typically be used within the context of MenuRadioGroup.
 */

export function MenuRadio(_ref) {
  var name = _ref.name,
      children = _ref.children,
      _ref$shouldCloseMenuO = _ref.shouldCloseMenuOnSelect,
      shouldCloseMenuOnSelect = _ref$shouldCloseMenuO === void 0 ? true : _ref$shouldCloseMenuO,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? noop : _ref$onSelect,
      checkedProp = _ref.checked,
      _ref$delayBeforeClosi = _ref.delayBeforeClosingMenuUponSelection,
      delayBeforeClosingMenuUponSelection = _ref$delayBeforeClosi === void 0 ? 125 : _ref$delayBeforeClosi,
      other = _objectWithoutProperties(_ref, ["name", "children", "shouldCloseMenuOnSelect", "onSelect", "checked", "delayBeforeClosingMenuUponSelection"]);

  var _useContext = useContext(MenuRadioGroupContext),
      onChange = _useContext.onChange,
      checkedContext = _useContext.checked;

  var isChecked = typeof checkedProp === 'undefined' ? checkedContext === name : checkedProp;
  var handleSelect = useCallback(function () {
    onChange(name);
    onSelect();
  }, [name, onChange, onSelect]);
  var renderIconAfter = useCallback(function () {
    return /*#__PURE__*/React.createElement(CheckedSVG, {
      color: theme.colors.palette.brandPrimary,
      $isChecked: isChecked
    });
  }, [isChecked]);
  return /*#__PURE__*/React.createElement(MenuButton, _extends({}, other, {
    onSelect: handleSelect,
    shouldCloseMenuOnSelect: shouldCloseMenuOnSelect,
    role: "menuitemradio",
    iconAfter: renderIconAfter,
    "aria-checked": isChecked,
    delayBeforeClosingMenuUponSelection: delayBeforeClosingMenuUponSelection
  }), children);
}